import { FieldPattern } from '..';

import { CHECKBOX } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class CheckboxField extends FormFieldWithInitialValue {
  readonly type: string = CHECKBOX;
  isTNC: boolean;
  tncEnum: string | undefined;
  shouldHideReceiveUpdates: boolean;
  notificationChannels: string[];
  shouldShowOnlyLabel: boolean;

  constructor(checkboxFieldProps: FormFieldsType, initialValue = false) {
    super(checkboxFieldProps, initialValue);
    this.isTNC = checkboxFieldProps.is_tnc ?? false;
    if (checkboxFieldProps.tnc_enum) {
      this.tncEnum = checkboxFieldProps.tnc_enum;
    }
    this.shouldHideReceiveUpdates =
      checkboxFieldProps.should_hide_receive_updates ?? false;
    this.notificationChannels = checkboxFieldProps.notificationChannels ?? [];
    this.shouldShowOnlyLabel =
      checkboxFieldProps.should_show_only_label ?? false;
    if (checkboxFieldProps.default_value) {
      this.initialValue = checkboxFieldProps.default_value;
    }
  }

  match<T>(p: FieldPattern<T>): T {
    return p.CheckBoxField(this);
  }
}

export default CheckboxField;
